/**
 * Table showing the most recent scans on the dashboard.
 */

import { useNavigate } from 'react-router-dom';
import StatusBadge from '@/components/common/StatusBadge';
import { completedWithErrors, formatDate } from '@/utils/formatters';
import type { Scan } from '@/types/scan';

interface RecentScansProps {
  scans: Scan[];
}

export default function RecentScans({ scans }: RecentScansProps) {
  const navigate = useNavigate();
  const recent = scans.slice(0, 5);

  return (
    <div className="card">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-700">Recent Scans</h3>
        <button
          onClick={() => navigate('/scans')}
          className="text-xs font-medium text-indigo-600 hover:text-indigo-800"
        >
          View all
        </button>
      </div>

      <div className="space-y-3">
        {recent.length === 0 ? (
          <p className="py-4 text-center text-sm text-gray-500">No scans yet.</p>
        ) : (
          recent.map((scan) => (
            <div
              key={scan.id}
              className="flex items-center justify-between rounded-md border px-3 py-2 hover:bg-gray-50 cursor-pointer"
              onClick={() => navigate(`/scans`)}
            >
              <div>
                <p className="text-sm font-medium text-gray-900">{scan.name}</p>
                <p className="text-xs text-gray-500">{formatDate(scan.created_at)}</p>
              </div>
              <StatusBadge status={scan.status} withErrors={completedWithErrors(scan)} />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
